<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  // All mobile nav destinations ordered: first 3 appear in the tab bar, the rest in the More sheet.
  items: { type: Array, default: () => [] },
})

const route = useRoute()

const showMoreDrawer  = ref(false)
const tabItems        = computed(() => props.items.slice(0, 3))
const moreNavItems    = computed(() => props.items.slice(3))
const showMoreButton  = computed(() => moreNavItems.value.length > 0)

const currentPath = computed(() => {
  const path = route.path
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
})

function isActive(item) {
  return (item.match || [item.route]).includes(currentPath.value)
}
</script>

<template lang="pug">
nav.mobile-bottom-nav(aria-label="Primary navigation")
  RouterLink.mobile-nav-item(
    v-for="item in tabItems"
    :key="item.route"
    :to="item.route"
    :class="{ active: isActive(item) }"
  )
    i.mobile-nav-icon(:class="item.icon")
    span.mobile-nav-label {{ item.label }}

  button.mobile-nav-item(v-if="showMoreButton" type="button" @click="showMoreDrawer = true")
    i.mobile-nav-icon.ph.ph-dots-three-outline
    span.mobile-nav-label More

Drawer(v-model:visible="showMoreDrawer" header="More" position="bottom" class="h-auto")
  ul.flex.flex-col.gap-1
    li(v-for="item in moreNavItems" :key="item.label")
      RouterLink.nav-btn.w-full(
        v-if="item.route"
        :to="item.route"
        @click="showMoreDrawer = false"
      )
        i.nav-icon(:class="item.icon")
        span.nav-text {{ item.label }}
      button.nav-btn.w-full.cursor-pointer(
        v-else
        type="button"
        @click="item.command(); showMoreDrawer = false"
      )
        i.nav-icon(:class="item.icon")
        span.nav-text {{ item.label }}
</template>

<style lang="scss" scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  display: flex;
  align-items: stretch;
  height: var(--bottom-nav-height, 64px);
  background-color: var(--app-navbar-bg);
  border-top: 1px solid var(--line-clr);
  // respect the iOS home-indicator safe area
  padding-bottom: env(safe-area-inset-bottom);
}

.mobile-nav-item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  text-decoration: none;
  color: var(--nav-btn-clr);
  opacity: 0.7;

  &.active {
    opacity: 1;
    color: var(--active-bg-clr);
    font-weight: 600;
  }
}

.mobile-nav-icon {
  font-size: 1.4rem;
  line-height: 1;
}

.mobile-nav-label {
  font-size: 0.7rem;
  line-height: 1;
  white-space: nowrap;
}
</style>
